import axios from "axios";

const axiosInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "/api"
      : "http://localhost:5005/api",
  ...(process.env.NODE_ENV === "development" && {
    headers: {
      apiKey: process.env.REACT_APP_API_KEY,
    },
  }),
});

export default axiosInstance;
